module.exports = __webpack_public_path__ + "img/SWP_Sword_2H_01.93af37f6.png";